import type { VrCaptureRequestPayload } from '@indutrust/factory-model';
import { http, HttpResponse } from 'msw';
import {
  vrCaptureRequestStore,
  type VrCaptureRequestMockRow,
} from './vr-capture-request.mock-state';

let nextCaptureRequestId = 1000;

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function parseVrCaptureRequestPayload(body: unknown): VrCaptureRequestPayload {
  if (!isRecord(body)) {
    return {};
  }

  return {
    message: typeof body['message'] === 'string' ? body['message'] : undefined,
    phone: typeof body['phone'] === 'string' ? body['phone'] : undefined,
    preferred_visit_window:
      typeof body['preferred_visit_window'] === 'string'
        ? body['preferred_visit_window']
        : undefined,
  };
}

/**
 * MSW handlers for assisted VR capture booking
 * (`POST /factories/{factoryId}/vr_capture_requests`).
 */
export function vrCaptureRequestHandlers(baseUrl: string) {
  return [
    http.post(
      `${baseUrl}/factories/:factoryId/vr_capture_requests`,
      async ({ params, request }) => {
        const factoryId = Number(params['factoryId']);
        if (!Number.isFinite(factoryId) || factoryId <= 0) {
          return HttpResponse.json(
            { error: 'Invalid factory id' },
            { status: 422 }
          );
        }

        const body = parseVrCaptureRequestPayload(await request.json());
        const created: VrCaptureRequestMockRow = {
          created_at: new Date().toISOString(),
          factory_id: factoryId,
          factory_name: `Factory ${factoryId}`,
          id: nextCaptureRequestId++,
          message: body.message,
          phone: body.phone,
          preferred_visit_window: body.preferred_visit_window,
          status: 'pending',
        };
        vrCaptureRequestStore.push(created);
        return HttpResponse.json(created, { status: 201 });
      }
    ),
  ];
}
